module.exports = __webpack_public_path__ + "img/link-dark.752aec41.svg";